import type { LibraryFolder } from "@/services/foldersService";

/** Ancestor chain from root to the given folder (empty for library root / virtual ids). */
export function buildFolderPath(
  folderId: string | null | undefined,
  folders: LibraryFolder[]
): LibraryFolder[] {
  if (!folderId || folderId === "spaces" || folderId.startsWith("space-")) {
    return [];
  }
  const path: LibraryFolder[] = [];
  let current = folders.find((f) => f.id === folderId);
  const seen = new Set<string>();
  while (current && !seen.has(current.id)) {
    seen.add(current.id);
    path.unshift(current);
    current = current.parentId
      ? folders.find((f) => f.id === current!.parentId)
      : undefined;
  }
  return path;
}
